export default __webpack_public_path__ + "static/media/sweet_tofu_slushie.b15da6b7.JPG";